import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const FILES_BASE = BACKEND_URL; // /uploads/... served from root

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cps_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fullUrl(maybePath) {
  if (!maybePath) return "";
  if (maybePath.startsWith("http")) return maybePath;
  return `${BACKEND_URL}${maybePath}`;
}
